import { createContext, useContext, useState } from "react";

const FeeContext = createContext();

export const FeeProvider = ({ children }) => {
  const [feeData, setFeeData] = useState(null);

  return (
    <FeeContext.Provider value={{ feeData, setFeeData }}>
      {children}
    </FeeContext.Provider>
  );
};

export const useFee = () => useContext(FeeContext);
